import React, { useCallback, useMemo, useState } from "react";
import { useLazyQuery } from "@apollo/react-hooks";
import { Breadcrumb, message } from "antd";
import gql from "fraql";
import { get } from "lodash";
import ReportTableDisplayResults from "../utils/ReportTableDisplayResults";
import LayoutPageHeader from "../../LayoutPageHeader";
import ReportDataExportButton from "../ReportDataExportButton";
import CompetitorsWithOtherCompetitionsReportForm from "./CompetitorsWithOtherCompetitionsReportForm";
import "../SummaryReportPage.scss";

const GET_COMPETITORS_WITH_OTHER_COMPETITIONS_REPORT = gql`
  query CompetitorsWithOtherCompetitionsReportPage_GetCompetitorsWithOtherCompetitionsReport($CompetitionIds: [ID!]!) {
    CompetitorsWithOtherCompetitionsReport(competitionIds: $CompetitionIds) {
      result
    }
  }
`;

function CompetitorsWithOtherCompetitionsReportPage() {
  const [getReport, { loading, data, error }] = useLazyQuery(GET_COMPETITORS_WITH_OTHER_COMPETITIONS_REPORT, {
    onError: err => {
      console.error(err);
      message.error("Failed to generate the report.");
    },
  });

  const reportData = useMemo(() => { 
  
    const raw = get(data, "CompetitorsWithOtherCompetitionsReport.result", []);
    
    return raw;
  
  }, [data]);

  const tableColumns = [
    { title: "Sport", dataIndex: "Sport", key: "Sport" },
    { title: "Competition", dataIndex: "Competition", key: "Competition" },
    { title: "Age group lower", dataIndex: "AgeGroupLower", key: "AgeGroupLower" },
    { title: "Age group upper", dataIndex: "AgeGroupUpper", key: "AgeGroupUpper" },
    { title: "Id", dataIndex: "PersonId", key: "PersonId" },
    { title: "First name", dataIndex: "FirstName", key: "FirstName" },
    { title: "Last name", dataIndex: "LastName", key: "LastName" },
    { title: "Competing age", dataIndex: "CompetingAge", key: "CompetingAge" },
    { title: "Gender", dataIndex: "Gender", key: "Gender" },
    { title: "Role", dataIndex: "Role", key: "Role" },
  ];

  const handleSubmitForm = useCallback(
    async (values, actions) => {
      const { CompetitionIds } = values;
      getReport({ variables: { CompetitionIds } });
      actions.setSubmitting(false);
    },
    [getReport],
  );

  const [filteredRows, setFilteredRows] = useState([]);
    const filteredRowKeys = useMemo(() => {
      return filteredRows.map(row => row.key);
    }, [filteredRows]);

  let actions;

  if (reportData) {
    actions = (
      <>
        <ReportDataExportButton
          title="Competitors With Other Competitions Report"
          data={{ rows: reportData, columns: tableColumns.map(column => column.dataIndex) }}
          selectedRowKeys={filteredRowKeys}
          disabled={loading}
        />
      </>
    );
  } else {
    actions = null;
  }

  return (
    <>
      <div
        style={{
          borderBottom: "2px solid #e8e8e8",
          padding: "15px 24px",
        }}
      >
        <Breadcrumb style={{ marginBottom: 10 }}>
          <Breadcrumb.Item>Reports</Breadcrumb.Item>
          <Breadcrumb.Item>CompetitorsWithOtherCompetitionsReportPage Report</Breadcrumb.Item>
        </Breadcrumb>

        <LayoutPageHeader title="Competitors With Other Competitions Report" extra={actions} />
      </div>

      <div className="summary-report__container">
        <div className="summary-report__flex-container">
          <div className="summary-report__left-sidebar">
            <div className="summary-report__left-sidebar-content">
              <CompetitorsWithOtherCompetitionsReportForm handleSubmit={handleSubmitForm} />
            </div>
          </div>
          <div className="summary-report__content">
            <ReportTableDisplayResults data={reportData} loading={loading} error={error} columns={tableColumns} setFilteredRows={setFilteredRows} />
          </div>
        </div>
      </div>
    </>
  );
}

export default CompetitorsWithOtherCompetitionsReportPage;
